const getHeaderHeight = () => {
	const mainHeader = document.querySelector(".header-wrapper");
	return mainHeader ? mainHeader.offsetHeight : 0;
};

let lastScrollY = 0;

const headerHeight = () => {
	const root = document.querySelector(":root");
	root.style.setProperty("--main--header--height", getHeaderHeight() + "px");
};

const headerTop = () => {
	const root = document.querySelector(":root");
	const auxiliaryHeader = document.querySelector("#header-auxiliar");

	if (!auxiliaryHeader) return;

	const currentScrollY = Math.max(window.scrollY, 0);
	const scrollDifference = currentScrollY - lastScrollY;

	if (currentScrollY === 0 || scrollDifference <= -10) {
		root.style.setProperty("--main--header--top", "0px");
		lastScrollY = currentScrollY;
	} else if (scrollDifference >= 150) {
		root.style.setProperty(
			"--main--header--top",
			auxiliaryHeader.offsetHeight + "px"
		);
		lastScrollY = currentScrollY;
	}
};

const layoutScroll = () => {
	document.addEventListener("scroll", (el) => {
		headerTop();
	});
};

const setHTMLClass = () => {
	const html = document.querySelector("html");
	const sessionName = "init-say-hello";
	// if (!document.referrer.includes("creactivitat.com")) {
		// if (window.sessionStorage.getItem(sessionName) !== "false") {
			// window.sessionStorage.setItem(sessionName, "false");
			html.classList.add("say-hello");
		// }
	// }
};

const resetHTMLClass = () => {
	const html = document.querySelector("html");
	html.classList.remove("say-hello");
};

const setHeaderProps = () => {
	headerHeight();
	lastScrollY = Math.max(window.scrollY, 0);
	headerTop();
};

export { setHeaderProps, layoutScroll, setHTMLClass, resetHTMLClass };
